import React, { useEffect, useState } from "react";
import { getReleaseNotes } from "../../services/releaseNotesService";
import ReleaseNotesSection from "./component/ReleaseNotesSection";

const ReleaseNotes = () => {
  const [releaseNotes, setReleaseNotes] = useState([]);
  const salutationIdx = Math.floor(Math.random() * 3);
  const salutations = ["Welcome Back!", "Howdy!", "Welcome to Narnia!"];
  useEffect(() => {
    getReleaseNotes()
      .then((response) => {
        console.log("Received the response from the data", response.data);
        setReleaseNotes([...response.data.releaseNotes]);
      })
      .catch((err) => {
        console.log("Error occured when getting data from backend:", err);
      });
  }, []);

  return (
    <React.Fragment>
      <h1>{salutations[salutationIdx]}</h1>
      {releaseNotes.map((note) => {
        return <ReleaseNotesSection releaseNote={note} />;
      })}
    </React.Fragment>
  );
};

export default ReleaseNotes;
